import { User } from '../../../types';

export type FamilyInfoFormProps = {
  goNext: () => void;
  goBack: () => void;
  translation: { [key: string]: string };
  registration: {
    user: Partial<
      Pick<
        User,
        'zip_code' | 'state' | 'adult_family_members' | 'child_family_members' | 'senior_family_members'
      >
    >;
  };
};
